import React, { AllHTMLAttributes, useEffect, useState } from "react";
import { observer } from "mobx-react-lite";
import cx from "classnames";
import { Hooks } from "@xt/xtbase";
//import store from "store";
import styles from "./index.module.scss";
import { waitRes } from "@/utils/axios";
import { get_enterpriseAuthInfo } from "@/api/xt-user";
import store from "@/store";
import { useRouter } from "next/router";
import Company from "./Company";
import Personal from "./Personal";
import XtSvg from "@/components/Xt/Svg";
import XtDrowdown from "@/components/Xt/Dropdown";
interface PageInfoProps {
  /** 是否是个人认证 */
  isPersonalAuth: boolean;
  /** 是否是企业认证 */
  isEnterpriseAuth: boolean;
}

interface VerificationProps extends AllHTMLAttributes<HTMLElement> {
  attr?: any;
}
const { useTranslation } = Hooks;

const list = Array.from({ length: 10000 }, (v, i) => ({
  key: "" + i,
  name: "tecxadfdfadsfadfasdft 哈u你发个" + i,
}));
const Verification: React.FC<VerificationProps> = ({ className }) => {
  const t = useTranslation();
  const router = useRouter();
  //const {isLogin} = store.user;
  const [pageInfo, setPageInfo] = useState({} as PageInfoProps);
  const [showCompany, setShowCompany] = useState(false);
  const [titleShow, setTitleShow] = useState(false);

  /** useEffect */
  useEffect(() => {
    // enterpriseAuthInfo();
    store.user.getUserInfo();
  }, []);
  /** method */
  const enterpriseAuthInfo = async () => {
    const { data: res, err } = await waitRes(get_enterpriseAuthInfo);
    if (!err) {
      setTitleShow(true);
      setPageInfo(res);
    }
  };

  const switchTab = (tab: boolean) => {
    setShowCompany(tab);
  };

  return (
    <div className={cx(styles.confirm, className)}>
      {
          titleShow && (
        <h6>
              <>
                {!pageInfo.isPersonalAuth && !pageInfo.isEnterpriseAuth ? (
                  <span>
                    <span className={cx(styles["confirm-tit"])} style={{ fontWeight: "bold" }}>
                      {/* {showCompany ? t("account.companyConfirm") : t("account.PersonalRealNameAuthentication")} */}
                      { t("account.companyConfirm")}
                    </span>
                    <span
                      style={{ marginLeft: "30px", fontWeight: 400, color: "#45BF76", fontSize: "14px", cursor: "pointer" }}
                      onClick={() => {
                        switchTab(showCompany ? false : true);
                      }}
                    >
                      {/* {showCompany ? t("account.switchtoperson") : t("account.switchtocompany")} */}
                    </span>
                  </span>
                ) : (
                  <span className={cx(styles["confirm-tit"])} style={{ fontWeight: "bold" }}>
                    {!pageInfo.isPersonalAuth && pageInfo.isEnterpriseAuth ? t("account.companyConfirm") : t("account.PersonalRealNameAuthentication")}
                  </span>
                )}
                {/* <XtDrowdown
              className="bar"
              list={list}
              value={"1"}
              virtual
              search={{ placeholder: "gggg" }}
              trigger={["click"]}
              overflowTip
              onChange={(key, item) => {
                console.log(key);
              }}
            ></XtDrowdown> */}
              </>
            
        </h6>
      )
      }
      {pageInfo.isEnterpriseAuth || showCompany ? <Company /> : <Personal />}
    </div>
  );
};
export default observer(Verification);
